<template>
  <div id="packet-add-update">
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <div class="row">
          <div class="col-md-12">
            <div class="card" style="margin-bottom: 9px">
              <div class="card-body">
                <input
                  autocomplete="false"
                  name="hidden"
                  type="text"
                  style="display: none"
                />

                <div class="row">
                  <div class="form-group col-md-6">
                    <label>{{this.$t('event.table.title')}}</label>
                    <el-input
                      placeholder
                      v-model="form.title"
                      :class="$inputError('title', validationErrors)"
                    ></el-input>
                    <span class="error">
                      {{ $errorMessage("title", validationErrors) }}
                    </span>
                  </div>

                  <div class="form-group col-md-3">
                    <ActionableLabel
                      :title="$t('tag')"
                      @new="tagModalVisible = true"
                      @refresh="$store.dispatch('getTags')"
                    />

                    <el-select v-model="form.tagID" :clearable="true" :placeholder="$t('event.textbox.select')">
                      <el-option
                        v-for="item in $store.state.tags.items"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id"
                      >
                        <div
                          style="
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: space-between;
                          "
                        >
                          <span style="float: left">{{ item.title }}</span>
                          <span
                            style="
                              float: right;
                              color: #8492a6;
                              font-size: 13px;
                              width: 15px;
                              height: 15px;
                              display: inline-block;
                            "
                            :style="'background-color: ' + item.color"
                          ></span>
                        </div>
                      </el-option>
                    </el-select>
                    <span class="error">
                      {{ $errorMessage("tagID", validationErrors) }}
                    </span>
                  </div>

                  <div class="col-md-3">
                    <label for="">{{this.$t('category')}}</label>
                    <el-select
                      v-model="form.categoryID"
                      :placeholder="$t('event.textbox.select')"
                    >
                      <el-option
                        v-for="item in $store.state.packetcategory.items"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>

                  <div class="form-group col-md-3">
                    <label style="display: block">{{this.$t('event.table.sequence')}}</label>

                    <el-input-number
                      :placeholder="$t('ex1')"
                      v-model="form.orderNO"
                      :min="1"
                      :class="$inputError('orderNO', validationErrors)"
                    ></el-input-number>
                    <span class="error">
                      {{ $errorMessage("orderNO", validationErrors) }}
                    </span>
                  </div>

                  <div class="form-group col-md-3">
                    <label style="display: block">{{ $t('event.tags.stockQuantity') }}</label>

                    <el-input-number
                      :placeholder="$t('ex1')"
                      v-model="form.stock"
                      :min="1"
                      :class="$inputError('stock', validationErrors)"
                    ></el-input-number>
                    <span class="error">
                      {{ $errorMessage("stock", validationErrors) }}
                    </span>
                  </div>

                  <div class="form-group col-md-3">
                    <label style="display: block">{{this.$t('price')}}</label>
                    <currency-input
                      class="el-input__inner"
                      v-model="form.price"
                      :class="$inputError('price', validationErrors)"
                      :currency="
                        $enums.currency.find(
                          (k) =>
                            k.value ==
                            $store.state.event.event.settings.currency
                        ).title
                      "
                      locale="tr"
                    />
                    <span class="error">
                      {{ $errorMessage("price", validationErrors) }}
                    </span>
                  </div>

                  <div class="form-group col-md-3">
                    <label style="display: block">{{this.$t('taxRate')}} (%)</label>

                    <el-input-number
                      :placeholder="$t('ex1')"
                      v-model="form.taxRate"
                      :min="0"
                      :class="$inputError('taxRate', validationErrors)"
                    ></el-input-number>
                    <span class="error">
                      {{ $errorMessage("taxRate", validationErrors) }}
                    </span>
                  </div>
                </div>

                <div class="row" style="margin-top: 20px">
                  <div class="col-md-12">
                    <label for>{{this.$t('packDesc')}}</label>
                    <quill-editor ref="myQuillEditor" :options="editorOption" v-model="form.details" />
                  </div>
                </div>

                <div class="row" style="margin-top: 20px">
                  <div class="col-md-6">
                    <ActionableLabel
                      :title="$t('oneDay')"
                  
                      @new="addNewDay = true"
                    />
                    <el-select
                      v-model="form.selectedDays"
                      multiple
                      :placeholder="$t('enums.inputTypes.multiChoice')"
                    >
                      <el-option
                        v-for="item in $store.state.days.items"
                        :key="item.date"
                        :label="
                          item.title +
                          ' (' +
                          moment(item.date).format('D MMMM YYYY, dddd') +
                          ')'
                        "
                        :value="item.date"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="col-md-6">
                    <ActionableLabel
                      :title="$t('autoSubEvent')"
                      @new="addSubEvent = true"
                      @refresh="$store.dispatch('getSubEvents')"
                    />
                    <el-select
                      v-model="form.subEvents"
                      multiple
                      :placeholder="$t('enums.inputTypes.multiChoice')"
                    >
                      <el-option
                        v-for="item in $store.state.subevents.items"
                        :key="item.id"
                        :label="item.title"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div style="margin-top: 20px" class="row">
                  <div class="col-md-6">
                    <label style="display: block" for>{{this.$t('secret')}}:</label>
                    <el-switch
                      v-model="form.isHidden"
                      :active-text="$t('event.variables.yes')"
                      :inactive-text="$t('event.variables.no')"
                      :active-value="1"
                      :inactive-value="0"
                    ></el-switch>
                    <el-alert
                      style="margin-top: 10px"
                      :closable="false"
                      :title="$t('secretPackDesc')"
                      type="info"
                    ></el-alert>
                  </div>
                  <div class="col-md-6">
                    <label style="display: block" for>{{this.$t('acreditaionMode')}}:</label>
                    <el-switch
                      v-model="form.accreditation"
                      :active-text="$t('event.variables.yes')"
                      :inactive-text="$t('event.variables.no')"
                      :active-value="1"
                      :inactive-value="0"
                    ></el-switch>
                    <el-alert
                      style="margin-top: 10px"
                      :closable="false"
                      :title="$t('acreditationDesc')"
                      type="info"
                    ></el-alert>
                  </div>

                  <div class="col-md-6">
                    <label style="display: block" for
                      >{{this.$t('invitationCode')}}:</label
                    >
                    <el-switch
                      v-model="form.invitationRequired"
                      :active-text="$t('event.variables.yes')"
                      :inactive-text="$t('event.variables.no')"
                    ></el-switch>
                    <el-alert
                      style="margin-top: 10px"
                      :closable="false"
                      :title="$t('invitationDesc')"
                      type="info"
                    ></el-alert>
                  </div>
                </div>

                <div
                  class="col-md-12"
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0;
                    margin-top: 20px;
                  "
                >
                  <div v-if="form.id != null">
                    <el-popconfirm
                      @confirm="deleteItem"
                      :confirmButtonText="$t('event.variables.yes')"
                      :cancelButtonText="$t('event.buttons.cancel')"
                      icon="el-icon-info"
                      iconColor="red"
                      :title="$t('event.textbox.toDelete')"
                    >
                      <el-button
                        slot="reference"
                        type="danger"
                        icon="fas fa-trash"
                        >{{ $t('event.table.delete') }}</el-button
                      >
                    </el-popconfirm>
                  </div>
                  <div
                    class="text-right"
                    style="
                      display: flex;
                      flex: 1;
                      align-items: center;
                      justify-content: flex-end;
                    "
                  >
                    <el-button-group>
                      <el-button
                        type="warning"
                        @click="
                          $emit('closeMe');
                          showInfo = false;
                        "
                        >{{$t('event.buttons.close')}}</el-button
                      >
                      <el-button type="success" @click="save">{{$t("event.buttons.save")}}</el-button>
                    </el-button-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="form.id != null"
      @click="showInfo = !showInfo"
      style="
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 10px 0px;
      "
    >
      <i :class="!showInfo ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
    </div>
    <transition name="slide-fade">
      <ItemInfo :data="form" v-if="showInfo" />
    </transition>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="tagModalVisible"
      :title="$t('addTag')"
      width="80%"
      append-to-body=""
    >
      <TagAddUpdate
        @closeMe="tagModalVisible = false"
        @itemAdded="itemAddedTag"
        :data="null"
      />
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="addNewDay"
      :title="$t('addDay')"
      width="690px"
      append-to-body
    >
      <DayAddUpdate
        @closeMe="addNewDay = false"
        @itemAdded="itemAddedDay"
        :data="null"
      />
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="addSubEvent"
      :title="$t('event.tags.addSubEvent')"
      width="80%"
      append-to-body
    >
      <SubEventAddUpdate
        @closeMe="addSubEvent = false"
        @itemAdded="itemAddedSubEvent"
        :data="null"
      />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import ItemInfo from "./ItemInfo";
import TagAddUpdate from "./TagAddUpdate";
import DayAddUpdate from "./DayAddUpdate";
import SubEventAddUpdate from "./SubEventAddUpdate";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import moment from "moment";

import { quillEditor } from "vue-quill-editor";
export default {
  components: {
    ItemInfo,
    quillEditor,
    TagAddUpdate,
    DayAddUpdate,
    SubEventAddUpdate,
  },
  name: "PacketAddUpdate",
  props: ["data"],
  data() {
    return {
      form: {
        id: null,
        title: null,
        orderNO: 0,
        details: null,
        tagID: null,
        stock: 0,
        price: 0,
        taxRate: 0,
        currency: 0,
        isHidden: 0,
        accreditation: 0,
        accomodation: 0,
        transfer: 0,
        chair: 0,
        selectedDays: [],
        subEvents: [],
        categoryID: null,
        invitationRequired: false,
      },

      editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }],
              ['clean'],
              ['link', 'image', 'video']
            ],
            syntax: {
              highlight: text => hljs.highlightAuto(text).value
            }
          }
      },
      
      logoPercent: 0,
      axios,
      validationErrors: [],
      showInfo: false,
      moment,
      tagModalVisible: false,
      addNewDay: false,
      addSubEvent: false,
    };
  },
  mounted() {
    this.$refs.myQuillEditor.quill.getModule("toolbar").addHandler("image", () => {
      this.selectLocalImage();
    });

    this.$refs.myQuillEditor.quill.root.setAttribute("data-placeholder", this.$t('enterText'));

  },
  methods: {
    selectLocalImage() {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.click();
      input.onchange = () => {
        const file = input.files[0];
        if (/^image\//.test(file.type)) {
          this.saveToServer(file);
        } else {
          console.warn("You could only upload images.");
        }
      };
    },
    saveToServer(file) {
      const fd = new FormData();
      fd.append("image", file);
      const xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        axios.defaults.baseURL + "event/uploadImage?uploadType=areaMap&language="+this.$i18n.locale,
        true
      );
      xhr.setRequestHeader(
        "Authorization",
        "Bearer " + localStorage.getItem("token")
      );

      xhr.onload = () => {
        if (xhr.status === 200) {
          const body = JSON.parse(xhr.responseText);
          if (body.alert.hasError == false) {
            const url = body.data.item.url;
            this.insertToEditor(url);
          } else {
            this.$message.error(body.alert.message);
          }
        }
      };

      xhr.send(fd);
    },
    insertToEditor(url) {
      const range = this.$refs.myQuillEditor.quill.getSelection();
      this.$refs.myQuillEditor.quill.insertEmbed(
        range.index,
        "image",
        `${url}`
      );
    },
    itemAddedTag(item) {
      this.$store.dispatch("getTags");
      this.form.tagID = item;
    },
    itemAddedDay(item) {
      this.form.selectedDays = [...this.form.selectedDays, item.date];
    },
    itemAddedSubEvent(item) {
      this.$store.dispatch("getSubEvents");
      this.form.subEvents = [...this.form.subEvents, item.id];
    },
    deleteItem() {
      var index = this.$store.state.packets.items.findIndex(
        (k) => k.id == this.form.id
      );
      if (index != -1) {
        this.$emit("deleteMe", index);
        this.$emit("closeMe");
      }
    },
    save() {
      this.validationErrors = [];
      axios
        .post("packet/addorupdate", {
          ...this.form,
          selectedDays: this.form.selectedDays.map((k) => {
            return {
              date: k,
            };
          }),
          currency: this.$store.state.event.event.settings.currency,
        })
        .then((res) => {
          this.validationErrors = res.data.validationErrors;
          if (res.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            this.$message.success(res.data.alert.message);
            if (this.form.id == null) {
              this.$emit("itemAdded", res.data.data);
              this.form = {
                id: null,
                title: null,
                orderNO: 0,
                details: null,
                tagID: null,
                stock: 0,
                price: 0,
                taxRate: 0,
                currency: 0,
                isHidden: 0,
                accreditation: 0,
                accomodation: 0,
                transfer: 0,
                chair: 0,
                selectedDays: [],
                subEvents: [],
                categoryID: null,
                invitationRequired: false,
              };
            } else {
              this.$emit("itemUpdated", JSON.parse(JSON.stringify(this.form)));
              if (this.showInfo) {
                this.showInfo = false;
                setTimeout(() => {
                  this.showInfo = true;
                }, 350);
              }
            }
          }
        });
    },
    logoProgress(event) {
      this.logoPercent = event.percent;
    },
    logoSuccess(response) {
      this.logoPercent = 0;
      if (response.alert.hasError) {
        this.$message.error(response.alert.message);
      } else {
        this.$message.success(response.alert.message);
        this.form.image = response.data;
      }
    },
  },
  watch: {
    data: function (newVal) {
      this.showInfo = false;
      if (newVal != undefined && newVal != null) {
        this.form = {
          ...this.data,
          selectedDays: this.data.dayRestrictions
            .filter((k) => k != null)
            .map((k) => k.date),
        };
        this.validationErrors = [];
      } else {
        this.form = {
          id: null,
          title: null,
          orderNO: 0,
          details: null,
          tagID: null,
          stock: 0,
          price: 0,
          taxRate: 0,
          currency: 0,
          isHidden: 0,
          accreditation: 0,
          accomodation: 0,
          transfer: 0,
          chair: 0,
          selectedDays: [],
          subEvents: [],
          categoryID: null,
          invitationRequired: false,
        };
      }
    },
  },
  created() {
    this.$store.dispatch("getPacketCategories");
    if (this.data != undefined && this.data != null) {
      this.form = {
        ...this.data,
        selectedDays: this.data.dayRestrictions
          .filter((k) => k != null)
          .map((k) => k.date),
      };
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/PacketAddUpdate.vue